import { useEffect, useState } from 'react'
import { CALLBACK_REMINDER_SPACE_VARIABLE, callbackReminderSpace } from '@/shared/theme/callbackReminderSpace'

const useCallbackReminderSpace = () => {
  const [stack, setStack] = useState<HTMLElement | null>(null)

  useEffect(() => {
    if (!stack) return undefined

    const root = document.documentElement
    const observer = new ResizeObserver(([entry]) => {
      root.style.setProperty(CALLBACK_REMINDER_SPACE_VARIABLE, callbackReminderSpace(entry.contentRect.height))
    })
    observer.observe(stack)

    return () => {
      observer.disconnect()
      root.style.removeProperty(CALLBACK_REMINDER_SPACE_VARIABLE)
    }
  }, [stack])

  return setStack
}

export default useCallbackReminderSpace
